import React from 'react';
import PropTypes from "prop-types";

export default function TextMessage({item}) {
  return (
    <div className="messageText">
      {!item.confirmed && <div>{__("Send...")}</div>}
      {item.text.split('\n')
        .map((line, key) => {
          return <span key={key}>{line}<br/></span>
        })}
    </div>
  );
}

TextMessage.propTypes = {
  item: PropTypes.shape({
    confirmed: PropTypes.bool.isRequired,
    text: PropTypes.string.isRequired
  })
};
